import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "languages" }
const _hoisted_4 = { class: "list" }
const _hoisted_5 = { class: "dot" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "list" }
const _hoisted_8 = { class: "dot gold" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "list" }
const _hoisted_11 = { class: "dot red" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "list" }
const _hoisted_14 = { class: "dot green" }
const _hoisted_15 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ic = _resolveComponent("ic")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('cv.skills')), 1),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("article", null, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.skillsProgramming')), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills.programming.languages.good, (skill, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "good"
            }, _toDisplayString(skill), 1))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills.programming.languages.ok, (skill, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(skill), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills.programming.list, (skill, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "listitem",
              key: index,
              style: _normalizeStyle({
            marginTop: _ctx.skills.programming.space.includes(index) ? '0.5em' : '0',
          })
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_ic, { icon: "star" })
              ]),
              _createElementVNode("span", { innerHTML: skill }, null, 8, _hoisted_6)
            ], 4))
          }), 128))
        ])
      ]),
      _createElementVNode("article", null, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.skillsTechnical')), 1),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills.technical.list, (skill, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "listitem",
              key: index,
              style: _normalizeStyle({
            marginTop: _ctx.skills.technical.space.includes(index) ? '0.5em' : '0',
          })
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_ic, { icon: "star" })
              ]),
              _createElementVNode("span", { innerHTML: skill }, null, 8, _hoisted_9)
            ], 4))
          }), 128))
        ])
      ]),
      _createElementVNode("article", null, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.skillsScience')), 1),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills.science.list, (skill, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "listitem",
              key: index,
              style: _normalizeStyle({
            marginTop: _ctx.skills.science.space.includes(index) ? '0.5em' : '0',
          })
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_ic, { icon: "star" })
              ]),
              _createElementVNode("span", { innerHTML: skill }, null, 8, _hoisted_12)
            ], 4))
          }), 128))
        ])
      ]),
      _createElementVNode("article", null, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.skillsSoft')), 1),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills.soft.list, (skill, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "listitem",
              key: index
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_ic, { icon: "star" })
              ]),
              _createElementVNode("span", { innerHTML: skill }, null, 8, _hoisted_15)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}